define('analytics/view-polst.controller',['angular'], function (angular) {
    'use strict';
    var ViewPolstCtrl = function ($scope, $location, $routeParams, $filter, $localStorage, $mdToast, $document, userService, dataEntryService, $window, $mdDialog, $sce, helper, analyticsService, user, Papa) {
        $scope.user = user.data.User;
        // Functions for correct forms
        $scope.correctForms = [];
        $scope.adRejectedFormTable = {
            order: 'created',
            limit: 10,
            page: 1
        };
        $scope.adAcceptedFormTable = {
            order: 'created',
            limit: 10,
            page: 1
        };
        $scope.pendingFormTable = {
            order: 'created',
            limit: 10,
            page: 1
        };
        $scope.formTable = {
            order: 'created',
            limit: 10,
            page: 1
        };
        $scope.form_type = 'Accepted POLST';
        $scope.mode = 'accepted';
        $scope.formStates = [{
            label: 'Accepted POLST',
            value: 'accepted'
        }, {
            label: 'Pending Signature POLST',
            value: 'pending'
        }, {
            label: 'Rejected POLST',
            value: 'rejected'
        }, {
            label: 'Accepted Advance Directives',
            value: 'accepted-ad'
        }, {
            label: 'Rejected Advance Directives',
            value: 'rejected-ad'
        }];
        $scope.mode = 'accepted';
        $scope.viewChanged = function () {
            console.log($scope.mode);
            if ($scope.mode === 'accepted') {
                $scope.formType = 'Accepted';
                $scope.form_type = 'Accepted POLST';
            } else if ($scope.mode === 'rejected') {
                $scope.formType = 'Rejected';
                $scope.form_type = 'Rejected POLST';
            } else if ($scope.mode === 'pending') {
                $scope.formType = 'Pending';
                $scope.form_type = 'Pending POLST';
            } else if ($scope.mode === 'accepted-ad') {
                $scope.formType = 'AcceptedAD';
                $scope.form_type = 'Accepted Advance Directives';
            } else if ($scope.mode === 'rejected-ad') {
                $scope.formType = 'RejectedAD';
                $scope.form_type = 'Rejected Advance Directives';
            }
            $scope.exportReady = false;
            $scope.adRejectedExportReady = false;
            $scope.adAcceptedExportReady = false;
            $scope.rejectExportReady = false;
            $scope.pendingExportReady = false;
        };

        $scope.onPaginate = function (page, limit) {
            console.log('on paginate?');
            $scope.formTable.page = page;
            $scope.formTable.limit = limit;
            $scope.reorderForms();
        };

        $scope.searchInput = '';
        $scope.$watch('searchInput', function () {
            console.log($scope.mode);
            if ($scope.mode === 'accepted') {
                console.log('findMatches...');
                $scope.findMatches();
            } else if ($scope.mode === 'pending') {
                $scope.reorderPendingForms();
            } else if ($scope.mode === 'accepted-ad') {
                $scope.reorderAcceptedADs();
            } else if ($scope.mode === 'rejected-ad') {
                $scope.reorderRejectedADs();
            } else {
                $scope.reorderRejectedForms();
            }
        });
        $scope.findMatches = function () {
            $scope.onPaginate(1, $scope.formTable.limit);
        };
        $scope.initPolst = true;
        $scope.initAbbyy = true;
        $scope.initPending = true;
        $scope.initAD = true;

        analyticsService.getAcceptedADs().then(function (response) {
            $scope.acceptedADs = response.data;
            $scope.adAcceptedOnReorder('created');
            $scope.reorderRejectedADs();
            analyticsService.getRejectedADs().then(function (response) {
                $scope.initAD = false;
                $scope.rejectedADs = response.data;
                $scope.adRejectedOnReorder('created');
                $scope.reorderAcceptedADs();
            });
        });

        analyticsService.getOrgPendingForms().then(function (response) {
            $scope.initPending = false;
            $scope.pendingForms = response.data;
            $scope.pendingOnReorder('created');
            $scope.reorderPendingForms();
        });

        analyticsService.getPolstForms().then(function (response) {
            $scope.initPolst = false;
            $scope.forms = response.data;
            $scope.reorderForms();
        });
        $scope.reorderAcceptedADs = function () {
            $scope.adAcceptedExportReady = false;
            var start = (($scope.adAcceptedFormTable.page - 1) * $scope.adAcceptedFormTable.limit);
            var end = start + $scope.adAcceptedFormTable.limit;

            $scope.adAcceptedCorrectForms = [];
            if ($scope.searchInput === '') {
                if ($scope.adAcceptedForms !== undefined) {
                    for (var i = start; i < end && i < $scope.adAcceptedForms.length; i++) {
                        $scope.adAcceptedCorrectForms.push($scope.adAcceptedForms[i]);
                    }
                }
            }
            if ($scope.searchInput !== '') {

                $scope.adAcceptedCorrectForms = [];

                if ($scope.adAcceptedCorrectForms !== undefined) {
                    for (var i = start; i < end && i < $scope.pendingForms.length; i++) {
                        if ($scope.adAcceptedForms[i].afid.toString().indexOf($scope.searchInput) >= 0 || $scope.adAcceptedForms[i].fname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || $scope.adAcceptedForms[i].lname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || ($scope.adAcceptedForms[i].fname + ' ' + $scope.adAcceptedForms[i].lname).toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0) {
                            $scope.adAcceptedCorrectForms.push($scope.adAcceptedForms[i]);
                        }
                    }

                }
            }
        };
        $scope.reorderRejectedADs = function () {
            $scope.adRejectedExportReady = false;
            var start = (($scope.adRejectedFormTable.page - 1) * $scope.adRejectedFormTable.limit);
            var end = start + $scope.adRejectedFormTable.limit;

            $scope.adRejectedCorrectForms = [];
            if ($scope.searchInput === '') {
                if ($scope.adRejectedForms !== undefined) {
                    for (var i = start; i < end && i < $scope.adRejectedForms.length; i++) {
                        $scope.adRejectedCorrectForms.push($scope.adRejectedForms[i]);
                    }
                }
            }
            if ($scope.searchInput !== '') {

                $scope.adRejectedCorrectForms = [];

                if ($scope.pendingForms !== undefined) {

                    for (var i = start; i < end && i < $scope.pendingForms.length; i++) {
                        if ($scope.adRejectedForms[i].afid.toString().indexOf($scope.searchInput) >= 0 || $scope.adRejectedForms[i].fname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || $scope.adRejectedForms[i].lname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || ($scope.adRejectedForms[i].fname + ' ' + $scope.adRejectedForms[i].lname).toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0) {
                            $scope.adRejectedCorrectForms.push($scope.adRejectedForms[i]);
                        }
                    }

                }
            }
        };
        $scope.reorderForms = function () {
            $scope.exportReady = false;
            var start = (($scope.formTable.page - 1) * $scope.formTable.limit);
            var end = start + $scope.formTable.limit;
            $scope.correctForms = [];
            if ($scope.searchInput === '') {
                if ($scope.forms !== undefined) {
                    for (var i = start; i < end && i < $scope.forms.length; i++) {
                        $scope.correctForms.push($scope.forms[i]);
                    }
                }
            } else if ($scope.searchInput !== '') {
                $scope.correctForms = [];
                if ($scope.forms !== undefined) {
                    for (var i = start; i < end && i < $scope.forms.length; i++) {
                        if ($scope.forms[i].id.toString().indexOf($scope.searchInput) >= 0 || $scope.forms[i].fname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || $scope.forms[i].lname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || ($scope.forms[i].fname + ' ' + $scope.forms[i].lname).toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0) {
                            $scope.correctForms.push($scope.forms[i]);
                        } else {
                        }
                    }
                }
            }
        };
        $scope.reorderPendingForms = function () {
            $scope.pendingExportReady = false;
            var start = (($scope.pendingFormTable.page - 1) * $scope.pendingFormTable.limit);
            var end = start + $scope.pendingFormTable.limit;

            $scope.pendingCorrectForms = [];
            if ($scope.searchInput === '') {
                if ($scope.pendingForms !== undefined) {
                    for (var i = start; i < end && i < $scope.pendingForms.length; i++) {
                        $scope.pendingCorrectForms.push($scope.pendingForms[i]);
                    }
                }
            }
            if ($scope.searchInput !== '') {

                $scope.pendingCorrectForms = [];

                if ($scope.pendingForms !== undefined) {

                    for (var i = start; i < end && i < $scope.pendingForms.length; i++) {
                        if ($scope.pendingForms[i].afid.toString().indexOf($scope.searchInput) >= 0 || $scope.pendingForms[i].fname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || $scope.pendingForms[i].lname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || ($scope.pendingForms[i].fname + ' ' + $scope.pendingForms[i].lname).toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0) {
                            $scope.pendingCorrectForms.push($scope.pendingForms[i]);
                        }
                    }

                }
            }
        };
        $scope.exportReady = false;
        $scope.pendingShowDownload = false;
        $scope.downloadPendingForms = function () {
            var formsToDownload = [];
            if ($scope.searchInput === '') {
                if ($scope.pendingForms !== undefined) {
                    for (var i = 0; i < $scope.pendingForms.length; i++) {
                        formsToDownload.push($scope.forms[i]);
                    }
                }
            }
            if ($scope.searchInput !== '') {
                if ($scope.pendingForms !== undefined) {
                    for (var i = 0; i < $scope.pendingForms.length; i++) {
                        if ($scope.pendingForms[i].afid.toString().indexOf($scope.searchInput) >= 0 || $scope.pendingForms[i].fname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || $scope.pendingForms[i].lname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || ($scope.pendingForms[i].fname + ' ' + $scope.pendingForms[i].lname).toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0) {
                            formsToDownload.push($scope.pendingForms[i]);
                        }
                    }

                }
            }
            Papa.unparse(formsToDownload).then(function (r) {
                var blob = new Blob(["\ufeff", r]);
                var url = URL.createObjectURL(blob);
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    $scope.pendingMsFile = blob;
                    $scope.pendingFileURL = 'forms.csv';
                    window.navigator.msSaveOrOpenBlob(blob, 'forms.csv');
                    $scope.pendingShowDownload = true;
                } else {
                    $scope.pendingShowDownload = true;
                    $scope.pendingFileURL = URL.createObjectURL(blob);
                }
                $scope.pendingExportReady = true;
            });
        };
        $scope.adAcceptedDownloadForms = function () {
            var formsToDownload = [];
            if ($scope.searchInput === '') {
                if ($scope.adAcceptedForms !== undefined) {
                    for (var i = 0; i < $scope.adAcceptedForms.length; i++) {
                        formsToDownload.push($scope.adAcceptedForms[i]);
                    }
                }
            }
            if ($scope.searchInput !== '') {
                if ($scope.adAcceptedForms !== undefined) {
                    for (var i = 0; i < $scope.adAcceptedForms.length; i++) {
                        if ($scope.adAcceptedForms[i].afid.toString().indexOf($scope.searchInput) >= 0 || $scope.adAcceptedForms[i].fname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || $scope.adAcceptedForms[i].lname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || ($scope.adAcceptedForms[i].fname + ' ' + $scope.adAcceptedForms[i].lname).toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0) {
                            formsToDownload.push($scope.adAcceptedForms[i]);
                        }
                    }

                }
            }
            Papa.unparse(formsToDownload).then(function (r) {
                var blob = new Blob(["\ufeff", r]);
                var url = URL.createObjectURL(blob);
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    $scope.msFile = blob;
                    $scope.adAcceptedFileURL = 'accepted_adv_directives.csv';
                    window.navigator.msSaveOrOpenBlob(blob, 'accepted_adv_directives.csv');
                    $scope.showDownload = true;
                } else {
                    $scope.showDownload = true;
                    $scope.adAcceptedFileURL = URL.createObjectURL(blob);
                }
                $scope.adAcceptedExportReady = true;
            });
        };
        $scope.adRejectedDownloadForms = function () {
            var formsToDownload = [];
            if ($scope.searchInput === '') {
                if ($scope.adRejectedForms !== undefined) {
                    for (var i = 0; i < $scope.adRejectedForms.length; i++) {
                        formsToDownload.push($scope.adRejectedForms[i]);
                    }
                }
            }
            if ($scope.searchInput !== '') {
                if ($scope.adRejectedForms !== undefined) {
                    for (var i = 0; i < $scope.adRejectedForms.length; i++) {
                        if ($scope.adRejectedForms[i].afid.toString().indexOf($scope.searchInput) >= 0 || $scope.adRejectedForms[i].fname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || $scope.adRejectedForms[i].lname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || ($scope.adRejectedForms[i].fname + ' ' + $scope.adRejectedForms[i].lname).toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0) {
                            formsToDownload.push($scope.forms[i]);
                        }
                    }

                }
            }
            Papa.unparse(formsToDownload).then(function (r) {
                var blob = new Blob(["\ufeff", r]);
                var url = URL.createObjectURL(blob);
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    $scope.msFile = blob;
                    $scope.adRejectedFileURL = 'rejected_adv_directives.csv';
                    window.navigator.msSaveOrOpenBlob(blob, 'rejected_adv_directives.csv');
                    $scope.showDownload = true;
                } else {
                    $scope.showDownload = true;
                    $scope.adRejectedFileURL = URL.createObjectURL(blob);
                }
                $scope.adRejectedExportReady = true;
            });
        };
        $scope.downloadForms = function () {
            var formsToDownload = [];
            if ($scope.searchInput === '') {
                if ($scope.forms !== undefined) {
                    for (var i = 0; i < $scope.forms.length; i++) {
                        formsToDownload.push($scope.forms[i]);
                    }
                }
            }
            if ($scope.searchInput !== '') {
                if ($scope.forms !== undefined) {
                    for (var i = 0; i < $scope.forms.length; i++) {
                        if ($scope.forms[i].afid.toString().indexOf($scope.searchInput) >= 0 || $scope.forms[i].fname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || $scope.forms[i].lname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || ($scope.forms[i].fname + ' ' + $scope.forms[i].lname).toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0) {
                            formsToDownload.push($scope.forms[i]);
                        }
                    }

                }
            }
            Papa.unparse(formsToDownload).then(function (r) {
                var blob = new Blob(["\ufeff", r]);
                var url = URL.createObjectURL(blob);
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    $scope.msFile = blob;
                    $scope.fileURL = 'forms.csv';
                    window.navigator.msSaveOrOpenBlob(blob, 'forms.csv');
                    $scope.showDownload = true;
                } else {
                    $scope.showDownload = true;
                    $scope.fileURL = URL.createObjectURL(blob);
                }
                $scope.exportReady = true;
            });
        };
        $scope.changeAssignedPhysician = function (l, ev) {
            $mdDialog.show({
                controller: 'ChangeAssignedPhysicianCtrl',
                templateUrl: 'dashboard/change-assigned-phys.html',
                locals: {polst: l, user: $scope.user},
                parent: document.body,
                clickOutsideToClose: true,
                fullscreen: true
            }).then(function (response) {
                if (response !== undefined) {
                    l.phsyician = response.phys;
                }
            });
        };
        $scope.adAcceptedOnReorder = function (order) {
            $scope.adAcceptedForms = helper.orderForms(order, $scope.acceptedADs);
            $scope.reorderAcceptedADs();
        };
        $scope.adRejectedOnReorder = function (order) {
            $scope.adRejectedForms = helper.orderForms(order, $scope.rejectedADs);
            $scope.reorderRejectedADs();
        };
        $scope.pendingOnReorder = function (order) {
            $scope.pendingForms = helper.orderForms(order, $scope.pendingForms);
            $scope.reorderPendingForms();
        };

        $scope.onReorder = function (order) {
            $scope.forms = helper.orderForms(order, $scope.forms);
            $scope.reorderForms();
        };

        $scope.openForm = function (form) {
            $location.path("dashboard").search({p: 1, f: form.id});
        };

        ////////////////////////////////////////
        // Functions for rejected forms
        $scope.rejectedForms = [];
        $scope.statusFilter = 'todos';

        $scope.rejectedFormTable = {
            order: 'created',
            limit: 10,
            page: 1
        };
        $scope.pendingOnPaginate = function (page, limit) {
            $scope.pendingFormTable.page = page;
            $scope.pendingFormTable.limit = limit;
            $scope.reorderPendingForms();
        };

        $scope.onPaginateReject = function (page, limit) {
            $scope.rejectedFormTable.page = page;
            $scope.rejectedFormTable.limit = limit;
            $scope.reorderRejectedForms();
        };
        $scope.adAcceptedOnPaginate = function (page, limit) {
            $scope.adAcceptedFormTable.page = page;
            $scope.adAcceptedFormTable.limit = limit;
            $scope.reorderAcceptedADs();
        };
        $scope.adRejectedOnPaginate = function (page, limit) {
            $scope.adRejectedFormTable.page = page;
            $scope.adRejectedFormTable.limit = limit;
            $scope.reorderRejectedADs();
        };

        $scope.reorderRejectedForms = function () {
            var start = (($scope.rejectedFormTable.page - 1) * $scope.rejectedFormTable.limit);
            var end = start + $scope.rejectedFormTable.limit;

            $scope.rejectedForms = [];
            if ($scope.searchInput === '') {

                if ($scope.Abbyforms !== undefined) {
                    for (var i = start; i < end && i < $scope.Abbyforms.length; i++) {
                        $scope.rejectedForms.push($scope.Abbyforms[i]);
                    }
                }
            }
            if ($scope.searchInput !== '') {
                $scope.rejectedForms = [];
                if ($scope.Abbyforms !== undefined) {
                    for (var i = start; i < end && i < $scope.Abbyforms.length; i++) {
                        if ($scope.Abbyforms[i].id.toString().indexOf($scope.searchInput.toLowerCase()) >= 0 || $scope.Abbyforms[i].mrn.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || $scope.Abbyforms[i].fname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || $scope.Abbyforms[i].lname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || ($scope.Abbyforms[i].fname + ' ' + $scope.Abbyforms[i].lname).toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0) {
                            $scope.rejectedForms.push($scope.Abbyforms[i]);
                        }
                    }

                }
            }
        };

        $scope.parseCSVData = function (af) {
            Papa.parse(af.csvData, {}).then(function (r) {
                var arrlength = r.data[0].length;
                for (var j = 0; j < arrlength; j++) {
                    if (r.data[0][j] === 'FirstName') {
                        af.fname = r.data[1][j];
                    }
                    if (r.data[0][j] === 'LastName') {
                        af.lname = r.data[1][j];
                    }
                    if (r.data[0][j] === 'MedicalRecordNumber') {
                        af.mrn = r.data[1][j];
                    }
                }
                $scope.ctr++;
                if ($scope.ctr === $scope.Abbyforms.length) {
                    $scope.reorderRejectedForms();
                }
            });
        };
        analyticsService.getAdminABBYYForms($scope.user.sessionID, $scope.statusFilter).then(function (response) {
            $scope.initAbbyy = false;
            $scope.Abbyforms = response.data;
            $scope.ctr = 0;
            for (var i = 0; i < $scope.Abbyforms.length; i++) {
                $scope.Abbyforms[i].firstname = '';
                $scope.Abbyforms[i].lastname = '';
                $scope.Abbyforms[i].mrn = '';
                $scope.parseCSVData($scope.Abbyforms[i]);
            }
        });
        $scope.downloadRejectedAD = function (f) {
            dataEntryService.getABBYYPDF($localStorage.sid, f.id).then(function (response) {
                var file = new Blob([response.data], {type: "application/pdf"});
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    $scope.msFile = file;
                    $scope.fileURL = 'tmp.pdf';
                    window.navigator.msSaveOrOpenBlob(file, 'polst.pdf');
                    $scope.showDownload = true;
                } else {
                    $scope.showDownload = true;
                    $scope.fileURL = URL.createObjectURL(file);
                    window.open($scope.fileURL, "_blank");
                }
            });
        };
        $scope.generateADPDF = function (f) {
            userService.downloadADById(f.id).then(function (response) {
                var file = new Blob([response.data], {type: "application/pdf"});
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    $scope.msFile = file;
                    $scope.fileURL = 'tmp.pdf';
                    window.navigator.msSaveOrOpenBlob(file, 'polst.pdf');
                    $scope.showDownload = true;
                } else {
                    $scope.showDownload = true;
                    $scope.fileURL = URL.createObjectURL(file);
                    window.open($scope.fileURL, "_blank");
                }
            });
        };
        // Used by both
        $scope.generatePDF = function (f) {
            userService.downloadFormById(f.id).then(function (response) {
                var file = new Blob([response.data], {type: "application/pdf"});
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    $scope.msFile = file;
                    $scope.fileURL = 'tmp.pdf';
                    window.navigator.msSaveOrOpenBlob(file, 'polst.pdf');
                    $scope.showDownload = true;
                } else {
                    $scope.showDownload = true;
                    $scope.fileURL = URL.createObjectURL(file);
                    window.open($scope.fileURL, "_blank");
                }
            });
        };

        $scope.formType = 'Accepted';

        $scope.onChange = function (formState) {
            $scope.formType = formState;
            $scope.exportReady = false;
            $scope.rejectExportReady = false;
        };

        $scope.onReorderRejects = function (order) {
            $scope.forms = helper.orderForms(order, $scope.Abbyforms);
            $scope.reorderAbbyyForms();
        };

        $scope.openAbbyyPDF = function (l) {
            dataEntryService.getABBYYPDF($scope.user.sessionID, l.id).then(function (response) {
                var file = new Blob([response.data], {type: "application/pdf"});
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    $scope.msFile = file;
                    $scope.fileURL = 'tmp.pdf';
                    window.navigator.msSaveOrOpenBlob(file, 'polst.pdf');
                    $scope.showDownload = true;
                } else {
                    $scope.showDownload = true;
                    $scope.fileURL = URL.createObjectURL(file);
                    window.open($scope.fileURL, "_blank");
                }
            });
        };
        $scope.rejectExportReady = false;
        $scope.rejectDownloadForms = function () {
            var formsToDownload = [];
            if ($scope.searchInput === '') {

                if ($scope.Abbyforms !== undefined) {
                    for (var i = 0; i < $scope.Abbyforms.length; i++) {
                        formsToDownload.push($scope.Abbyforms[i]);
                    }
                }
            }
            if ($scope.searchInput !== '') {
                if ($scope.Abbyforms !== undefined) {
                    for (var i = 0; i < $scope.Abbyforms.length; i++) {
                        if ($scope.Abbyforms[i].id.toString().indexOf($scope.searchInput.toLowerCase()) >= 0 || $scope.Abbyforms[i].mrn.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || $scope.Abbyforms[i].fname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || $scope.Abbyforms[i].lname.toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0 || ($scope.Abbyforms[i].fname + ' ' + $scope.Abbyforms[i].lname).toLowerCase().indexOf($scope.searchInput.toLowerCase()) >= 0) {
                            formsToDownload.push($scope.Abbyforms[i]);
                        }
                    }

                }
            }
            Papa.unparse({data: formsToDownload, fields: ['department_id','department_name',	'facility', 'id','formStatus','created',
                    'lastModified', 'patientID', 'physicianID', 'orgid', 'afNotes', 'reject_reason', 'mrn', 'form_type', 'date_submitted', 'firstname', 'lastname', 'lname', 'fname']}).then(function (r) {
                var blob = new Blob(["\ufeff", r]);
                var url = URL.createObjectURL(blob);
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    $scope.msFile = blob;
                    $scope.rejectFileURL = 'rejected.csv';
                    window.navigator.msSaveOrOpenBlob(blob, 'rejected.csv');
                    $scope.showDownload = true;
                } else {
                    $scope.showDownload = true;
                    $scope.rejectFileURL = URL.createObjectURL(blob);
                }
                $scope.rejectExportReady = true;
            });
        };


    };
    ViewPolstCtrl.$inject = ['$scope', '$location', '$routeParams', '$filter', '$localStorage', '$mdToast', '$document', 'userService', 'dataEntryService', '$window', '$mdDialog', '$sce', 'helper', 'analyticsService', 'user', 'Papa'];
    return ViewPolstCtrl;
});

